module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABIklEQVQ4T82UsUoDQRRFz/0FiYVIsNHSb9BUBjsLQRAsFfwAW7Gy8A8Cgo1FOqs0KZJeFGwEO2sLP8DmysDuslmyM7OSwqmW5c2Zd2fuu2LFS8t4tve7nCNpXtYvAG1vA6/ASwfgBvADnEh6bwInwJOkUQ7Q9hC4AHaBW0n3TaCBQV1CDGz7GtgEesCbpJtVAKszW4HAHhB9GEmDosOybh4DfgHHMblhcwEkfLe98l/uMA0E1oHLRod3koILqpXdIfABnNc312WV/7OBHW2Tlvz/gLUwmIVJyRm7oKL1DhsGzeE9S7qKAU+BA0lnKZrtoxAIkoa2H4CppMcFY9teA8ZAiK/PFBToFxG3BRxK+m6blJ0iPTKYBLtUwboUmEVJFP0CZeueFauYWjMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/twoliterature.png
// module id = mRjA
// module chunks = 18